import React, { useEffect, useState } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from '@material-ui/core'
import { CommissionSettlement } from '../types'

interface Props {
  settlement?: CommissionSettlement
  mutating: boolean
  open: boolean
  onClose: () => void
  onConfirm: (reason: string) => void
}

const SettlementDeleteDialog: React.FC<Props> = ({ settlement, mutating, open, onClose, onConfirm }) => {
  const [reason, setReason] = useState('')

  useEffect(() => {
    if (!open) setReason('')
  }, [open])

  const normalizedReason = reason.trim()
  return (
    <Dialog open={open} onClose={mutating ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Eliminar liquidación</DialogTitle>
      <DialogContent>
        <Typography gutterBottom>
          Esta acción marcará la liquidación como eliminada y todas sus comisiones volverán a estar disponibles para
          liquidar. Si incluía bono de meta, también quedará disponible nuevamente.
        </Typography>
        <Typography gutterBottom>
          La liquidación original se conservará para auditoría. Esta acción no revierte transferencias bancarias
          externas.
        </Typography>
        <TextField
          id="settlement-deletion-reason"
          autoFocus
          fullWidth
          required
          margin="normal"
          variant="outlined"
          label="Motivo de eliminación"
          value={reason}
          inputProps={{ maxLength: 500 }}
          onChange={event => setReason(event.target.value)}
        />
        {settlement ? <Typography variant="caption">Liquidación: {settlement._id}</Typography> : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={mutating}>
          Volver
        </Button>
        <Button
          color="secondary"
          variant="contained"
          disabled={mutating || !normalizedReason}
          onClick={() => onConfirm(normalizedReason)}
        >
          {mutating ? 'Eliminando…' : 'Confirmar eliminación'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SettlementDeleteDialog
